import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQAccordion({
  items
}: {
  items: FAQItemProps[];
}) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-1">
      {items.map((item, index) => <div key={index} className="border border-teal-dim/20 rounded-lg overflow-hidden bg-card transition-colors duration-200 hover:border-teal-dim/40" data-id="element-2">
          <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/50" onClick={() => setActiveIndex(activeIndex === index ? null : index)} aria-expanded={activeIndex === index} data-id="element-3">
            <span className="font-heading font-medium text-lg text-text-primary pr-4" data-id="element-4">
              {item.question}
            </span>
            <motion.div animate={{
          rotate: activeIndex === index ? 180 : 0
        }} transition={{
          duration: 0.2,
          ease: 'easeInOut'
        }} className="flex-shrink-0 text-teal-dim" data-id="element-5">
              <ChevronDownIcon className="w-5 h-5" data-id="element-6" />
            </motion.div>
          </button>
          <AnimatePresence initial={false} data-id="element-7">
            {activeIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-8">
                <div className="px-6 pb-5 text-text-secondary leading-relaxed border-t border-teal-dim/10 pt-3" data-id="element-9">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}